import logo from './Logo.png'
import home_slider1 from './home_slider1.png'
import home_slider2 from './home_slider2.png'
import home_slider3 from './home_slider3.png'
import home_slider4 from './home_slider4.png'
import who_img1 from './who_img1.png'
import who_img2 from './who_img2.JPG'
import product1 from './product1.jpg'
import product2 from './product2.jpg'
import product3 from './product3.jpg'
import product4 from './product4.jpg'
import product5 from './product5.jpg'
import product6 from './product6.jpg'
import product7 from './product7.jpg'
import product9 from './product9.jpg'
import home_vid from './home-vid.mov'
import count from './count.jpg'
import laser2 from './laser2.jpg'
import laser1 from './laser1.jpg'
import home1 from './home1.JPG'
import home2 from './home2.JPG'
import home3 from './home3.JPG'
import home4 from './home4.JPG'
import home5 from './home5.JPG'




const web_images = {
    'logo': logo,
    'home_slider1': home_slider1,
    'home_slider2': home_slider2,
    'home_slider3': home_slider3,
    'home_slider4': home_slider4,
    'who_img1': who_img1,
    'who_img2': who_img2,
    'product1': product1,
    'product2': product2,
    'product3': product3,
    'product4': product4,
    'product5': product5,
    'product6': product6,
    'product7': product7,
    'product9': product9,
    'home_vid': home_vid,
    'count': count,
    'laser1': laser1,
    'laser2': laser2,
    'home1': home1,
    'home2': home2,
    'home3': home3,
    'home4': home4,
    'home5': home5,
}


export {web_images}